module.exports = __webpack_public_path__ + "media/images/front/popular_contents_01-2d39b27c96843fe6fe17eb328ae97afa.jpg";